import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { setDeleteLoading } from "../../menu/menuSlice";
import {
    errorAlertHandle,
    successAlertHandle,
} from "../../../../utils/utilFunctions";

export const addDocument = createAsyncThunk(
    "app/addDocument",
    async (data, { dispatch, rejectWithValue }) => {
      try {
        const config = { headers: { "Content-Type": "application/json" } };
        const body = JSON.stringify(data);
        const res = await axios.post("api/document", body, config);
        successAlertHandle("Hook added successfully!", dispatch);
        return res.data;
      } catch (err) {
        errorAlertHandle(err, dispatch);
        return rejectWithValue(err.response.data.error);
      }
    }
  );
  
  export const updateDocument = createAsyncThunk(
    "app/updateDocument",
    async (data, { dispatch, rejectWithValue }) => {
      try {
        const config = { headers: { "Content-Type": "application/json" } };
        const body = JSON.stringify(data);
        const res = await axios.put("api/document", body, config);
        successAlertHandle("Hook updated successfully!", dispatch);
        return res.data;
      } catch (err) {
        errorAlertHandle(err, dispatch);
        return rejectWithValue(err.response.data.error);
      }
    }
  );
  
  export const deleteDocument = createAsyncThunk(
    "app/deleteDocument",
    async (id, { dispatch, rejectWithValue }) => {
      dispatch(setDeleteLoading(true));
      try {
        const res = await axios.delete(`/api/document?id=${id}`);
        successAlertHandle("Hook deleted successfully!", dispatch);
        dispatch(setDeleteLoading(true));
        return res.data;
      } catch (err) {
        dispatch(setDeleteLoading(false));
        errorAlertHandle(err, dispatch);
        return rejectWithValue(err.response.data.error);
      }
    }
  );

export const getDocuments = createAsyncThunk(
    "app/getDocuments",
    async ({ start, limit, filters }) => {
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify({ ...filters });
      const res = await axios.post(
        `/api/document/filter?start=${start}&limit=${limit}`,
        body,
        config
      );
      return res.data;
    }
  );

  export const getDocumentTypes = async () => {
    try {
      const res = await axios.get(`/api/document/types`);
      return res.data;
    } catch (err) {
      throw new Error(err);
    }
  };